export default {
    GetterMembres(state) {
        if (state.membres)
            return state.membres
        else
            return []
    },
    GetterTotal(state) {
        return state.total
    }
}